<!-- Settings dialog mode -->
<div class="settings-overlay" *ngIf="isOpen && !isRouted" (click)="closeSettings()">
  <div class="settings-container" (click)="$event.stopPropagation()">
    <!-- Header Area with Admin Panel and Logout -->
    <div class="settings-header">
      <div class="header-buttons">
        <button class="admin-button">Admin Panel</button>
        <button class="logout-button">Logout</button>
        <button class="settings-icon-button">
          <i class="settings-icon"></i>
        </button>
      </div>
      <div class="header-welcome">
        Welcome, {{username}}
      </div>
      <div class="header-date">
        {{currentDate}}
      </div>
    </div>

    <!-- Main Content Area with Sidebar and Settings Panels -->
    <div class="settings-content">
      <!-- Content here -->
    </div>
  </div>
</div>

<!-- Settings page mode (when routed to /settings) -->
<div class="settings-page" *ngIf="isRouted">

  <div class="settings-page-content">
    <button class="back-button" (click)="closeSettings()">
      <i class="back-icon"></i>
    </button>
    <div class="user-profile">
      <div class="profile-avatar">
        <img src="assets/avatar.png" alt="User avatar" onerror="this.src='assets/mindmaps.png'">
      </div>
      <div class="profile-info">
        <div class="profile-username">{{username}}</div>
        <div class="profile-email">{{email}}</div>
      </div>
    </div>

    <div class="settings-heading">Settings</div>

    <div class="settings-layout">
      <div class="settings-menu">
        <div class="menu-item" [class.active]="activeMenuItem === 'App'" (click)="setActiveMenuItem('App')">
          <i class="item-icon app-icon"></i>
          <span class="item-text">App Preferences</span>
        </div>
        <div class="menu-item" [class.active]="activeMenuItem === 'Account'" (click)="setActiveMenuItem('Account')">
          <i class="item-icon account-icon"></i>
          <span class="item-text">Account Settings</span>
        </div>
      </div>

      <section class="settings-panel" *ngIf="activeMenuItem === 'App'">
        <h2 class="settings-panel__title">App Preferences</h2>

        <div class="settings-card">
          <h3 class="settings-card__title">Default homepage layout</h3>
          <p class="settings-card__hint">Applied to every visitor; admins can override on the fly via the header switcher.</p>

          <div class="settings-radioList" role="radiogroup" aria-label="Default homepage layout">
            <label *ngFor="let opt of layoutOptions"
                   class="settings-radio"
                   [class.settings-radio--active]="currentLayout === opt.value">
              <input type="radio"
                     name="blogLayout"
                     [value]="opt.value"
                     [checked]="currentLayout === opt.value"
                     (change)="setLayout(opt.value)">
              <span class="settings-radio__icon material-icons" aria-hidden="true">{{ opt.icon }}</span>
              <span class="settings-radio__body">
                <span class="settings-radio__label">{{ opt.label }}</span>
                <span class="settings-radio__hint">{{ opt.hint }}</span>
              </span>
            </label>
          </div>
        </div>
      </section>

      <section class="settings-panel" *ngIf="activeMenuItem === 'Account'">
        <h2 class="settings-panel__title">Account</h2>
        <div class="settings-card">
          <h3 class="settings-card__title">Signed in as</h3>
          <p class="settings-card__hint">{{ email }}</p>
        </div>
      </section>
    </div>

  </div>
</div>
